/**
 * Bundle shade picker — vanilla JS only (no jQuery).
 * Requires [data-bundle-picker] markup from product-template.liquid and theme.js variant events.
 */
(function initBundleShadePicker() {
  function run() {
    var bundleRoot = document.querySelector('[data-bundle-picker]');
    if (!bundleRoot) return;

    var REMOVE_ICON_HTML =
      '<span class="remove-color" style="display: none;">' +
      '<svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">' +
      '<rect y="0.5" width="24" height="24" rx="12" fill="black"></rect>' +
      '<path d="M9 9.5L15 15.5" stroke="white" stroke-width="1.2" stroke-linecap="round"></path>' +
      '<path d="M15 9.5L9 15.5" stroke="white" stroke-width="1.2" stroke-linecap="round"></path>' +
      '</svg></span>';

    var buttonContainer = bundleRoot.querySelector('.product-form__bundle-variants-buttons');
    var propertiesContainer = bundleRoot.querySelector('[data-bundle-properties]');
    var popup = bundleRoot.querySelector('#color-popup');
    var selectedCountEl = bundleRoot.querySelector('#selected-count');
    var totalCountEl = bundleRoot.querySelector('#total-count');
    var productForm = bundleRoot.closest('[data-product-form]');
    var submitBtn = productForm && productForm.querySelector('[data-add-to-cart]');
    var productSection = bundleRoot.closest('[data-section-type="product"]');
    var sectionId = productSection && productSection.getAttribute('data-section-id');
    var productJsonEl = sectionId
      ? document.getElementById('ProductJson-' + sectionId)
      : document.querySelector('[id^="ProductJson-"]');

    var activeSlotIndex = null;
    var slots = [];
    var currentVariant = null;

    function getProductData() {
      if (!productJsonEl) return null;
      try {
        return JSON.parse(productJsonEl.textContent);
      } catch (e) {
        return null;
      }
    }

    function getSizeSelector() {
      var index = bundleRoot.getAttribute('data-size-option-index');
      if (index !== null && index !== '') {
        return document.getElementById('SingleOptionSelector-' + index);
      }
      if (productForm) {
        return productForm.querySelector('.custom-product-form__controls-group .single-option-selector');
      }
      return null;
    }

    function parseCountFromValue(value) {
      var n = parseInt(value, 10);
      if (!isNaN(n) && n > 0) return n;
      var match = String(value).match(/\d+/);
      return match ? parseInt(match[0], 10) : 0;
    }

    function getSlotCountFromVariant(variant) {
      if (!variant) return 0;
      var i;
      for (i = 1; i <= 3; i++) {
        if (variant['option' + i]) {
          var count = parseCountFromValue(variant['option' + i]);
          if (count > 0) return count;
        }
      }
      return parseCountFromValue(variant.title);
    }

    function getSlotCount(variant) {
      var sizeSelect = getSizeSelector();
      if (sizeSelect && sizeSelect.value) {
        var fromSelect = parseCountFromValue(sizeSelect.value);
        if (fromSelect > 0) return fromSelect;
      }
      var fromVariant = getSlotCountFromVariant(variant);
      if (fromVariant > 0) return fromVariant;
      var initial = parseInt(bundleRoot.getAttribute('data-initial-slot-count'), 10);
      return !isNaN(initial) && initial > 0 ? initial : 0;
    }

    function findVariantById(id) {
      var product = getProductData();
      if (!product || !product.variants) return null;
      for (var i = 0; i < product.variants.length; i++) {
        if (String(product.variants[i].id) === String(id)) return product.variants[i];
      }
      return null;
    }

    function getVariantFromSelectedOptions() {
      var product = getProductData();
      if (!product || !product.variants || !productForm) return null;

      var selects = productForm.querySelectorAll('.single-option-selector');
      if (!selects.length) return null;

      for (var v = 0; v < product.variants.length; v++) {
        var variant = product.variants[v];
        var matches = true;

        for (var s = 0; s < selects.length; s++) {
          var optionKey = selects[s].getAttribute('data-index');
          if (!optionKey || variant[optionKey] !== selects[s].value) {
            matches = false;
            break;
          }
        }

        if (matches) return variant;
      }

      return null;
    }

    function syncMasterSelect(variant) {
      if (!variant || !productForm) return;
      var masterSelect = productForm.querySelector('[name="id"]');
      if (masterSelect && String(masterSelect.value) !== String(variant.id)) {
        masterSelect.value = variant.id;
      }
    }

    function getFilledCount() {
      var count = 0;
      for (var i = 0; i < slots.length; i++) {
        if (slots[i] && slots[i].variantId) count++;
      }
      return count;
    }

    function buildComponentsArray() {
      var components = [];

      for (var i = 0; i < slots.length; i++) {
        if (!slots[i] || !slots[i].variantId) continue;
        components.push({
          id: String(slots[i].variantId),
          qty: 1
        });
      }

      return components;
    }

    function buildComponentsJson() {
      return JSON.stringify(buildComponentsArray());
    }

    function isPayloadValid() {
      if (!isComplete()) return false;
      var expected = slots.length;
      var components = buildComponentsArray();
      return components.length === expected && expected === getSlotCount(currentVariant);
    }

    function isVariantSellable(variant) {
      if (!variant) return false;
      if (!variant.inventory_management) return true;
      return !!variant.available;
    }

    function isComplete() {
      return slots.length > 0 && getFilledCount() === slots.length;
    }

    function canAddToCart() {
      return isVariantSellable(currentVariant) && isPayloadValid();
    }

    function showFormError(message) {
      var errorWrapper = productForm && productForm.querySelector('[data-error-message-wrapper]');
      var errorMessage = productForm && productForm.querySelector('[data-error-message]');
      if (!errorMessage || !errorWrapper) return;
      errorMessage.textContent = message;
      errorWrapper.classList.remove('product-form__error-message-wrapper--hidden');
      errorWrapper.removeAttribute('aria-hidden');
    }

    function hideFormError() {
      var errorWrapper = productForm && productForm.querySelector('[data-error-message-wrapper]');
      if (!errorWrapper) return;
      errorWrapper.classList.add('product-form__error-message-wrapper--hidden');
      errorWrapper.setAttribute('aria-hidden', 'true');
    }

    function setLoadingState(isLoading) {
      if (!submitBtn) return;
      if (isLoading) {
        submitBtn.disabled = true;
        submitBtn.setAttribute('aria-disabled', 'true');
      } else {
        updateSubmitState();
      }
    }

    function buildAddToCartBody() {
      syncMasterSelect(currentVariant);
      syncLineItemProperties();

      if (window.theme && theme.Helpers && typeof theme.Helpers.serialize === 'function') {
        var body = theme.Helpers.serialize(productForm);
        if (body.indexOf('quantity=') === -1) {
          body += (body ? '&' : '') + 'quantity=1';
        }
        return body;
      }

      var params = new URLSearchParams();
      params.set('id', String(currentVariant.id));
      params.set('quantity', '1');
      params.set('properties[_components]', buildComponentsJson());
      return params.toString();
    }

    function postBundleAdd() {
      return fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: buildAddToCartBody()
      }).then(function (response) {
        return response.json().then(function (json) {
          if (json.status && json.status !== 200) {
            var err = new Error(json.description || json.message || 'Could not add bundle to cart');
            err.isSoldOut = /sold out/i.test(err.message);
            throw err;
          }

          var savedComponents =
            json.properties && (json.properties._components || json.properties['_components']);
          if (!savedComponents) {
            console.warn('Bundle added but _components property was not returned on the line item', json);
          }

          return json;
        });
      });
    }

    function wait(ms) {
      return new Promise(function (resolve) {
        setTimeout(resolve, ms);
      });
    }

    function refreshCartCount() {
      return fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (r) {
          return r.json();
        })
        .then(function (cart) {
          var countEls = document.querySelectorAll('.cart-Update');
          for (var i = 0; i < countEls.length; i++) {
            countEls[i].textContent = String(cart.item_count);
          }
        })
        .catch(function () {});
    }

    function addBundleToCart() {
      if (!isPayloadValid()) {
        showFormError('Please choose all ' + slots.length + ' shades before adding to cart.');
        updateSubmitState();
        return Promise.resolve();
      }

      hideFormError();
      setLoadingState(true);

      return postBundleAdd()
        .catch(function (error) {
          if (!error.isSoldOut) throw error;
          return wait(600).then(postBundleAdd);
        })
        .then(function () {
          hideFormError();
          document.dispatchEvent(new Event('cart:updated'));
          return refreshCartCount();
        })
        .catch(function (error) {
          console.error('Bundle add to cart failed', {
            variantId: currentVariant && currentVariant.id,
            slotCount: slots.length,
            components: buildComponentsArray(),
            message: error && error.message
          });
          var message = error && error.message ? error.message : 'Could not add bundle to cart.';
          if (error && error.isSoldOut) {
            message += ' This usually means a selected shade is out of stock, or the cart needs to be cleared after a previous failed bundle add.';
          }
          showFormError(message);
        })
        .then(function () {
          setLoadingState(false);
        });
    }

    function setSubmitEnabled(enabled) {
      if (!submitBtn) return;
      var on = !!enabled;
      submitBtn.disabled = !on;
      submitBtn.setAttribute('aria-disabled', on ? 'false' : 'true');
    }

    function updateSubmitState() {
      setSubmitEnabled(canAddToCart());
    }

    function scheduleSubmitStateUpdate() {
      setTimeout(updateSubmitState, 0);
      setTimeout(updateSubmitState, 50);
    }

    function updateCountDisplay() {
      if (selectedCountEl) selectedCountEl.textContent = String(getFilledCount());
      if (totalCountEl) totalCountEl.textContent = String(slots.length);
    }

    function syncLineItemProperties() {
      if (!propertiesContainer) return;
      propertiesContainer.innerHTML = '';

      function addProperty(name, value) {
        if (value === null || value === undefined || value === '') return;
        var input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'properties[' + name + ']';
        input.value = String(value);
        propertiesContainer.appendChild(input);
      }

      if (isComplete()) {
        addProperty('_components', buildComponentsJson());
      }
    }

    function clearSlotButton(button) {
      button.setAttribute('data-selected', 'false');
      var label = button.querySelector('.color-label');
      var removeIcon = button.querySelector('.remove-color');
      var preview = button.querySelector('img.color-preview');
      if (preview) preview.remove();
      if (label) label.textContent = 'Add';
      if (removeIcon) removeIcon.style.display = 'none';
    }

    function fillSlotButton(button, slot) {
      button.setAttribute('data-selected', 'true');
      var label = button.querySelector('.color-label');
      var removeIcon = button.querySelector('.remove-color');
      var existingImg = button.querySelector('img.color-preview');
      if (existingImg) existingImg.remove();

      if (slot.imgSrc) {
        var previewImg = document.createElement('img');
        previewImg.src = slot.imgSrc;
        previewImg.alt = slot.title || '';
        previewImg.className = 'color-preview';
        if (label) button.insertBefore(previewImg, label);
        else button.appendChild(previewImg);
      }

      if (label) label.textContent = slot.title || 'Add';
      if (removeIcon) removeIcon.style.display = 'inline-block';
    }

    function createSlotButton(index) {
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'add-color-btn';
      button.setAttribute('data-index', String(index));
      button.setAttribute('data-selected', 'false');
      button.innerHTML = '<span class="color-label">Add</span>' + REMOVE_ICON_HTML;
      return button;
    }

    function rebuildSlotButtons(count) {
      if (!count || count < 1) count = 1;
      slots = new Array(count);
      if (buttonContainer) {
        buttonContainer.innerHTML = '';
        for (var i = 0; i < count; i++) {
          buttonContainer.appendChild(createSlotButton(i));
        }
      }
      updateCountDisplay();
      syncLineItemProperties();
      updateSubmitState();
    }

    function resolveCurrentVariant() {
      var fromOptions = getVariantFromSelectedOptions();
      if (fromOptions) return fromOptions;

      var masterSelect = productForm && productForm.querySelector('[name="id"]');
      if (masterSelect && masterSelect.value) {
        var fromMaster = findVariantById(masterSelect.value);
        if (fromMaster) return fromMaster;
      }

      return currentVariant;
    }

    function applyVariant(variant) {
      if (!variant) variant = resolveCurrentVariant();
      currentVariant = variant || null;
      syncMasterSelect(variant);
      rebuildSlotButtons(getSlotCount(variant));
      scheduleSubmitStateUpdate();
    }

    function openPopup() {
      if (popup) popup.style.display = 'block';
    }

    function closePopup() {
      if (popup) popup.style.display = 'none';
      activeSlotIndex = null;
    }

    bundleRoot.addEventListener('click', function (e) {
      var addBtn = e.target.closest('.add-color-btn');
      if (addBtn && buttonContainer && buttonContainer.contains(addBtn)) {
        if (e.target.closest('.remove-color')) return;
        e.preventDefault();
        activeSlotIndex = parseInt(addBtn.getAttribute('data-index'), 10);
        openPopup();
        return;
      }

      var removeBtn = e.target.closest('.remove-color');
      if (removeBtn && buttonContainer && buttonContainer.contains(removeBtn)) {
        e.preventDefault();
        e.stopPropagation();
        var slotButton = removeBtn.closest('.add-color-btn');
        if (!slotButton) return;
        var index = parseInt(slotButton.getAttribute('data-index'), 10);
        slots[index] = null;
        clearSlotButton(slotButton);
        updateCountDisplay();
        syncLineItemProperties();
        updateSubmitState();
        return;
      }

      var colorItem = e.target.closest('#color-list li');
      if (colorItem && popup && popup.contains(colorItem) && activeSlotIndex !== null) {
        if (colorItem.getAttribute('data-variant-available') === 'false') return;
        var variantId = colorItem.getAttribute('data-variant-id');
        if (!variantId) return;

        var img = colorItem.querySelector('img');
        slots[activeSlotIndex] = {
          variantId: variantId,
          title: colorItem.getAttribute('data-color') || '',
          imgSrc: img ? img.getAttribute('src') : ''
        };

        var targetButton = buttonContainer.querySelector(
          '.add-color-btn[data-index="' + activeSlotIndex + '"]'
        );
        if (targetButton) fillSlotButton(targetButton, slots[activeSlotIndex]);

        updateCountDisplay();
        syncLineItemProperties();
        updateSubmitState();
        closePopup();
        return;
      }

      if (e.target.closest('.popup-header .close')) {
        e.preventDefault();
        closePopup();
      }
    });

    if (popup) {
      popup.addEventListener('click', function (e) {
        if (e.target === popup) closePopup();
      });
    }

    if (productForm) {
      productForm.addEventListener(
        'submit',
        function (e) {
          currentVariant = resolveCurrentVariant();
          syncMasterSelect(currentVariant);
          syncLineItemProperties();

          e.preventDefault();
          e.stopImmediatePropagation();

          if (!canAddToCart()) {
            showFormError('Please choose all ' + slots.length + ' shades before adding to cart.');
            updateSubmitState();
            return;
          }

          addBundleToCart();
        },
        true
      );

      productForm.addEventListener('change', function (e) {
        if (e.target && e.target.classList && e.target.classList.contains('single-option-selector')) {
          setTimeout(function () {
            applyVariant(resolveCurrentVariant());
          }, 0);
        }
      });
    }

    if (productSection) {
      productSection.addEventListener('variantChange', function (event) {
        setTimeout(function () {
          var variant = (event.detail && event.detail.variant) || resolveCurrentVariant();
          applyVariant(variant);
        }, 0);
      });
    }

    applyVariant(resolveCurrentVariant());
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
